import { Component, OnInit } from '@angular/core';
import { CmsComponentData } from '@spartacus/storefront';
import { CustomOurBrandsComponentData } from '../custom-our-brands/custom-our-brands.model';
import { CmsService } from '@spartacus/core';
import { combineLatest, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { CustomCmsItemComponentData } from '../custom-cms-item/custom-cms-item.model';

@Component({
  selector: 'app-custom-collections',
  templateUrl: './custom-collections.component.html',
  styleUrls: ['./custom-collections.component.scss'],
  standalone: false
})
export class CustomCollectionsComponent implements OnInit {
  animation = 'swipe';

  constructor(
    private componentData: CmsComponentData<CustomOurBrandsComponentData>,
    private cmsService: CmsService,
  ) {
  }

  items$: Observable<Observable<CustomCmsItemComponentData>[]> = this.componentData.data$.pipe(
    map((data) => data.items.trim().split(' ')
      .map((codes: string) => this.cmsService.getComponentData(codes))),
  );
  data$ = this.componentData.data$.pipe(map(component => component));

  ngOnInit(): void {
  }

}
